import { render, staticRenderFns } from "./SYYearlyFees.vue?vue&type=template&id=716ad4d4&scoped=true&"
import script from "./SYYearlyFees.vue?vue&type=script&lang=js&"
export * from "./SYYearlyFees.vue?vue&type=script&lang=js&"
import style0 from "./SYYearlyFees.vue?vue&type=style&index=0&id=716ad4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ad4d4",
  null
  
)

export default component.exports